const SELECTORS = {
  collectionBoostWrapper: '.boost-sd__filter-block',
  collectionFilterToolbar: '.boost-sd__toolbar',
  tollbarViewAS: '.boost-sd__toolbar-item--view-as',
  productCard: '.boost-sd__product-item',
  addToCartButton: '.boost-sd__btn-add-to-cart',
  switcherTemplate: '#imageSwitcher',
  productsListWrapper: '.boost-sd-layout',
  productListWrapperImgAttr: 'data-show-product-image',
  prodcutImageSwitcher: 'data-product-images-switcher',
  bttns: '.btn',
  bttnsImgAttr: 'data-product-image',
  bttnsActive: 'active',
};
const observerConfig = {
  childList: true, // Observe changes in the child nodes
  subtree: true, // Observe changes in all descendants of the target
};
/**
 * Function to change attribute & class to
 * switch displayed product images on listing page
 *
 * @param {HTMLDivElement} filterToolbar filter div element
 */
const switchProductImages = (filterToolbar) => {
  const switcherWrapper = filterToolbar.querySelector(`[${SELECTORS.prodcutImageSwitcher}]`);
  if (!switcherWrapper) return;

  const bttns = switcherWrapper.querySelectorAll(SELECTORS.bttns);
  const productsListWrapper = document.querySelector(SELECTORS.productsListWrapper);
  bttns.forEach((btn) => {
    const currentImages = btn.getAttribute(SELECTORS.bttnsImgAttr);
    btn.addEventListener('click', () => {
      switcherWrapper.querySelector(`${SELECTORS.bttns}.${SELECTORS.bttnsActive}`)?.classList.remove(`${SELECTORS.bttnsActive}`);
      if (!btn.classList.contains(`${SELECTORS.bttnsActive}`)) {
        btn.classList.add(`${SELECTORS.bttnsActive}`);
        productsListWrapper.setAttribute(SELECTORS.productListWrapperImgAttr, currentImages);
      }
    });
  });
};

/**
 * Function to render buttons to switch images
 *
 * @param {HTMLDivElement} filterToolbar filter toolbar div
 */
const renderImageSwitcher = (filterToolbar) => {
  const template = document.querySelector(SELECTORS.switcherTemplate);
  const templateContent = template ? template.content.cloneNode(true) : null;
  if (templateContent) {
    const tollbarViewAS = filterToolbar.querySelector(SELECTORS.tollbarViewAS);
    tollbarViewAS.parentNode.insertBefore(templateContent, tollbarViewAS.nextSibling);
    switchProductImages(filterToolbar);
  }
};

/**
 * Observer to observe boost widget load
 */
const boostRenderObserver = () => {
  const targetElement = document.querySelector(SELECTORS.collectionBoostWrapper);
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const filterToolbar = node.querySelector(SELECTORS.collectionFilterToolbar);
            if (filterToolbar) {
              observer.disconnect();
              renderImageSwitcher(filterToolbar);
            }
          }
        });
      }
    });
  });
  observer.observe(targetElement, observerConfig);
};

document.addEventListener('DOMContentLoaded', () => {
  boostRenderObserver();
});

window.addEventListener('SCE:add', () => {
  window.PXUTheme.jsAjaxCart.updateView('add');
});
